import types from '../../../../../../../actions/types';

export function getGames(data) {
    return {type: types.GET_GAMES.REQUEST, payload: {data}};
}



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/main/modules/games-main-actions.js